<template>
  <div id="app">
    <sidebar></sidebar>
    <main-component></main-component>
  </div>
</template>

<script>
import MainComponent from './components/MainComponent'
import Sidebar from './components/Sidebar'
// import router from './router'

export default {
  name: 'App',
  // router: router,
  components: {
    'main-component': MainComponent,
    'sidebar': Sidebar
  },
  mounted () {

  },
  data () {
    return {

    }
  }
}
</script>

<style>
  *{
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }
  #app {
    display: flex;
    flex-direction: row;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue